import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import { SearchBar } from '../../../molecules';
import { RootState } from '../../../redux/root';
import { setGlobalSearch } from '../../../redux/slices/filterSlice';

const DailyInspectionsSearchBox = () => {
  const dispatch = useDispatch();
  const globalFilter = useSelector((s: RootState) => s.filters.globalSearch);
  return (
    <Bar>
      <Heading>
        <TitleRow>
          <IconBadge>
            <SearchIcon fontSize="small" />
          </IconBadge>
          <Title>Your Inspection List</Title>
        </TitleRow>
        <Hint>
          Filter by project, permit, address, contact name, inspection type, or inspection ID.
        </Hint>
      </Heading>
      <SearchSlot>
        <SearchBar
          text={globalFilter}
          placeholder="Search project, permit, address, contact…"
          onChange={e => dispatch(setGlobalSearch(e))}
        />
      </SearchSlot>
    </Bar>
  );
};

export default DailyInspectionsSearchBox;

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 14px 18px;
  margin: 0 0 20px;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-xs);
  box-sizing: border-box;

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  @media print {
    display: none;
  }
`;

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const IconBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--primary-50);
  color: var(--primary-600);

  .MuiSvgIcon-root {
    font-size: 18px;
  }
`;

const Title = styled.h2`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--mainText);
  line-height: 1.2;
`;

const Hint = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  color: var(--neutral-500);
  line-height: 1.35;
`;

const SearchSlot = styled.div`
  flex-shrink: 0;
  width: 360px;
  max-width: 100%;

  > * {
    width: 100%;
  }

  @media (max-width: 720px) {
    width: 100%;
  }
`;
